<template>
  <div class="withdrawal_log">
    <div v-if="withdrawal.length > 0">
      <div class="commission_income_list flex" v-for="(item,index) in withdrawal" :key="index">
        <div class>
          <p>{{item.realname}}</p>
          <p class="c_i_time">{{item.apply_time_str}}</p>
        </div>
        <div class>
          <p class="c_i_price">+{{item.income_price}}</p>
          <p class="w_l_status col_B6B7B7" v-if="item.status != 2">{{item.status_str}}</p>
          <p class="w_l_status col_F5643D" v-if="item.status == 2">{{item.status_str}}</p>
        </div>
      </div>
    </div>
    <div v-else style="text-align:center;font-size:.75rem;color:#999;margin-top:1rem;">暂无记录</div>
  </div>
</template>

<script>
export default {
  name: "withdrawal_log",
  components: {},
  data() {
    return {
      withdrawal: []
    };
  },
  created() {
    this.get_tech_withdrawal();
  },
  methods: {
    get_tech_withdrawal() {
      this.axios({
        url: this.api.tech.get_tech_withdrawal,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.withdrawal = res.withdrawal;
        }
      });
    }
  }
};
</script>
<style scoped>
.w_l_status {
  font-size: 0.6rem;
  text-align: right;
}
.col_B6B7B7 {
  color: #b6b7b7;
}
.col_F5643D {
  color: #f5643d;
}
.commission_income_list {
  background-color: white;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  color: #484747;
  border-bottom: 1px solid #eee;
}
.c_i_price {
  color: #45b9bc;
  text-align: right;
}
.c_i_time {
  color: #838181;
  font-size: 0.6rem;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/withdrawal_log.vue